import { render, staticRenderFns } from "./LoginChooseMFAType.vue?vue&type=template&id=e71fe142"
import script from "./LoginChooseMFAType.vue?vue&type=script&lang=js"
export * from "./LoginChooseMFAType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports